module.exports = __webpack_public_path__ + "static/media/covi_sig_occ.f3646571.png";